import assetPath from '/app/packages/lebenslauf/constants/src/assets/template-4-preview.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')